<ng-container *appLoad="let individualId of individualId$">
  <app-audit-list
    [entityType]="entityType"
    [entityId]="individualId">
  </app-audit-list>
</ng-container> 